import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { ListWrapper } from '../../../../components/lists/ListWrapper';
import { ListHeader } from '../../../dashboard/lists/ListHeader';
import { ListItemLoader } from '../../../dashboard/lists/ListItemLoader';
import { MobileListItemLoader } from '../../../dashboard/lists/MobileListItemLoader';
import { DASHBOARD_LIST_COLUMN_WIDTHS } from '../../../../utils/dashboardSortUtils';

interface ListLoaderProps {
  title: ReactNode;
  head: ReactNode[];
}

export const LeveragedSkeleton = ({ title, head }: ListLoaderProps) => {
  const theme = useTheme();
  const downToXSM = useMediaQuery(theme.breakpoints.down('xsm'));

  return (
    <ListWrapper
      titleComponent={
        <Typography component="div" variant="h3" sx={{ mr: 4 }}>
          {title}
        </Typography>
      }
    >
      <>
        {!downToXSM && (
          <ListHeader
            head={head}
            firstColumnWidth={DASHBOARD_LIST_COLUMN_WIDTHS.POOL}
            buttonsColumnSize="big"
          />
        )}
        {!downToXSM ? (
          <>
            <ListItemLoader
              head={head}
              firstColumnWidth={DASHBOARD_LIST_COLUMN_WIDTHS.POOL}
              buttonsColumnSize="big"
              secondButton={true}
            />
            <ListItemLoader
              head={head}
              firstColumnWidth={DASHBOARD_LIST_COLUMN_WIDTHS.POOL}
              buttonsColumnSize="big"
              secondButton={true}
            />
          </>
        ) : (
          <MobileListItemLoader />
        )}
      </>
    </ListWrapper>
  );
};
